export default __webpack_public_path__ + "static/media/thue_xe_tu_lai_gia_re_hanoi.4035317e.svg";